<template>
    <div class="product-image" >
       <div class="image-wrap">
           <base-image
              :src="{'image': src.image, 'mobileImage': src.mobileImage, 'imageKey': src.imageKey}"
              :alt="alt"
              :stepNumber="stepNumber"
            />
        </div>
    </div>
</template>
<script>
import BaseImage from '@/shared/base-img';

export default {
    name: 'ProductImage',
    props: {
        src: {
            type: Object,
            required: true,
        },
        alt: {
            type: String,
            required: true,
        },
        stepNumber: {
          type: Number,
        }
    },
    components: {
       BaseImage,
    }
}
</script>
<style lang="scss">
    .product-image {
        .image-wrap {
            width: 144px;
            @media only screen and (max-width: $mobile) {
                width: 100%;
            }
        }
        @media only screen and (min-width: $mobile+1) {
            padding: 16px 16px 16px 0;
            justify-content: flex-start;
            .base-image_image {
                object-fit: contain;
            }
        }
    }
</style>
